export default "__VITE_ASSET__DZKWORtX__"